<ng-container [formGroup]="formGroup">
  <input
    #input
    [formControlName]="columnId"
    spellcheck="false"
    class="grid-input"
/></ng-container>
